import React from 'react'
import { Dropdown } from 'primereact/dropdown'
import { useIntl } from 'react-intl'
import './dropdownComp.scss'

const DropdownComp = ({
  name,
  value,
  options,
  optionLabel,
  optionValue,
  onChange,
  onFilter,
  valueTemplate,
  itemTemplate,
  optionDisabled,
  idPlaceHolder,
  filter = false,
  showClear,
  emptyMessage,
  emptyFilterMessage,
  disabled,
}) => {
  const { formatMessage: msg } = useIntl()

  return (
    <Dropdown
      value={value}
      options={options || []}
      name={name}
      optionLabel={optionLabel} // || 'name'
      optionValue={optionValue} // || '_id'
      onChange={onChange}
      onFilter={onFilter}
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      optionDisabled={optionDisabled}
      filter={filter}
      showClear={showClear}
      placeholder={msg({ id: idPlaceHolder || 'placeholder.select' })}
      emptyMessage={emptyMessage || msg({ id: 'placeholder.not.options' })}
      emptyFilterMessage={
        emptyFilterMessage || msg({ id: 'placeholder.not.options' })
      }
      style={{ width: '100%' }}
      pt={{
        item: ({ context }) => ({
          className: context.selected ? 'item-active' : undefined,
        }),
      }}
      disabled={disabled}
    />
  )
}

export default DropdownComp
